import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL!;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY!;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Check your .env file.');
}

// Bypass the Navigator LockManager entirely by providing a no-op lock.
// The LockManager deadlocks when multiple tabs or stale sessions compete.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const noopLock = (_name: string, _acquireTimeout: number, fn: () => Promise<any>) => fn();

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storage: window.localStorage,
    storageKey: 'sabbath-lunch-auth',
    lock: noopLock,
  },
});
